export default "__VITE_ASSET__DhOOP6w7__"